import { render, staticRenderFns } from "./PostCollectForm.vue?vue&type=template&id=58f7def6&"
import script from "./PostCollectForm.vue?vue&type=script&lang=ts&"
export * from "./PostCollectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f7def6')) {
      api.createRecord('58f7def6', component.options)
    } else {
      api.reload('58f7def6', component.options)
    }
    module.hot.accept("./PostCollectForm.vue?vue&type=template&id=58f7def6&", function () {
      api.rerender('58f7def6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaignFactory/Test/PostCollectForm.vue"
export default component.exports